<template>
  <v-app-bar class="header" flat dense light color="grey lighten-3">
    <!-- <back-page v-if="!hideBackPage && !cleanHeader"></back-page> -->
    <back-page v-if="!hideBackPage && !cleanHeader"></back-page>
    <v-btn class="refresh_btn" icon v-if="!hideRefresh  && !cleanHeader" @click="reloadPage()">
      <v-icon>refresh</v-icon>
    </v-btn>
    <slot name="left"></slot>
    <v-spacer v-if="!hideBackPage"></v-spacer>

    <v-menu :nudge-width="150" :nudge-left="75" transition="slide-y-transition" bottom offset-y  :close-on-content-click="false" v-if="!hideTitle  && !cleanHeader">
        <template v-slot:activator="{ on }">
          <v-btn class="header_btn" text light v-on="on">
            <v-avatar style="margin-right:8px;" size="25" tile="tile" ><img :src="Mote" /></v-avatar>
            <span>{{title}}</span>
          </v-btn>
        </template>
        <v-list >
          <v-list-item>
          <v-row align="center" justify="center" @keyup.enter="saveItem">
            <v-text-field v-model="name" hide-details="auto" label="Name"   dense class="ma-2" style="max-width:100px"/>
            <v-text-field v-model="udid"  hide-details="auto"  label="Udid" dense class="ma-2" style="max-width:100px"/>
            <v-btn  elevation="2" @click="saveItem" icon small>
              <v-icon>
                add
              </v-icon>
            </v-btn >
          </v-row>
          </v-list-item>
          <div v-if="!isMoteListEmpty">
            <v-list-item v-for="(item, index) in items" :key="index">
              <v-list-item @click="gotToMote(item.udid)" :class="{'choose':item.udid==moteUdid}">
               <v-avatar style="margin-right:8px;" size="25" tile="tile" ><img :src="Mote" /></v-avatar>
                <v-list-item-title>{{ item.name }}({{item.udid}})</v-list-item-title>
              </v-list-item>
              <v-btn icon small color="red" @click="deleteMote(item)">
                <v-icon>
                  delete
                </v-icon>
              </v-btn>
            </v-list-item>
          </div>
          <v-list-item v-else class="listEmpty">
            <v-list-item-title>empty</v-list-item-title>
          </v-list-item>
        </v-list>
    </v-menu>

    <!--<v-btn icon v-if="!hideAdd" @click="addMote">
      <v-icon>add</v-icon>
    </v-btn>

    <input-dialog :dialog="dialogState" @closeDialog="dialogState = $event"></input-dialog>-->
    <v-spacer v-if="!hideTitle"></v-spacer>

    <slot name="right"></slot>
    <v-btn icon v-if="!hideSearch && !cleanHeader" @click="goToJujue()">
      <v-icon>search</v-icon>
    </v-btn>
    <v-btn icon v-if="!hideMenu && !cleanHeader">
      <v-icon>more_vert</v-icon>
    </v-btn>
  </v-app-bar>
</template>
<script>
import BackPage from '@/components/BackPage';
import BackJujue from '@/components/BackJujue';
import Mote from '@/assets/images/apps/mote_512x512.png';
import InputDialog from './InputDialog.vue';

export default {
    data(){
      return {
        Mote,
        //dialogState:false,
        items : [
        ],
        udid:'',
        name:'',
        title:'',
        isMoteListEmpty:false
      }
    },
    props: {
      hideSearch: {
        type: Boolean
      },
      hideRefresh: {
        type: Boolean
      },
      hideBackPage: {
        type: Boolean
      },
      hideMenu: {
        type: Boolean
      },
      hideTitle: {
        type: Boolean
      },
      cleanHeader: {
        type: Boolean
      },
      /*hideAdd:{
        type: Boolean
      },*/
      moteUdid:{
        type:String
      }
    },
    components : {
      BackPage,
      BackJujue,
      InputDialog,
    },
    watch:{
      items(){
        if(this.items.length > 10){
          this.items.shift()
        }
      },
    },
    created(){
      if(!this.hideTitle){
        this.getMoteList();
        this.setTitle();
      }
    },
    methods : {
      setTitle(){
        if(this.moteUdid ===''){
          if(this.items.length!==0){
            let temp=this.items[this.items.length-1]
            if(temp.name!==''&&temp!=='undefined')
              this.title=temp.name
            else
              this.title=temp.udid
            this.gotToMote(temp.udid)
          }
          else{
            this.title='add mote'
            this.isMoteListEmpty=true
          }
        }
        else if(this.moteUdid !==undefined){
          let temp=this.items.find(element=>element.udid===this.moteUdid)
          if(temp !== undefined){
              if(temp.name!==''&&temp.name!=='undefined')
                this.title=temp.name
              else
                this.title=temp.udid
          }
          else{
            this.name=''
            this.udid=this.moteUdid
            this.saveItem()
            this.title=this.udid
          }
        }
      },
      getMoteList(){
        if(window.localStorage.getItem('arr')){
          let temp=JSON.parse(window.localStorage.getItem('arr'));
          temp.forEach(element => {
            this.items.push(element)
          });
        }
      },
      deleteMote(mote){
        let temp=this.items.filter(item=>item!=mote)
        this.items=temp
        this.saveFile()
        if(this.moteUdid===mote.udid){
          this.goToPage('')
          this.reloadPage()
        }
      },
      saveItem(){
        let temp={name:this.name,udid:this.udid}
        if(temp.name === ''){
          temp.name='undefined'
        }
        if(temp.udid != ''){
          this.add(temp)
          this.saveFile()
          this.gotToMote(temp.udid)
        }
        else{
          alert('Need to Input Udid')
        }
      },
      add(e) {
        this.items.push(e);
      },
      saveFile() {
        const data = JSON.stringify(this.items)
        window.localStorage.setItem('arr', data);
        console.log(JSON.parse(window.localStorage.getItem('arr')))
      },
      goToPage(page){
        this.$router.push(page);
      },
      gotToMote(mote){
        this.$router.push({path:'',query:{udid:mote}})
        this.reloadPage()
      },
      goToJujue(){
        window.location.href = 'https://jujue.app/browser';
      },
       reloadPage(){
        this.$router.go();
      },
      /*addMote(){
        this.dialogState=true
      }*/
    }
};
</script>
<style scoped>
.header{
  box-shadow: none;
  border:none;
  position: fixed;
  top: 0;
  z-index: 20;
}
.header_title{
  font-weight:bold;
}
.header_btn{
      font-weight: bold;
    font-size: 13pt;
    text-transform: none;

}
.refresh_btn{
      margin-left: -5px;
}
.choose{
  background-color:#dddddd;
}
.listEmpty{
  text-align: center;
}
</style>


